
  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      sectionId: {
        type: String,
        default: null
      }, 
      rect: {
        type: Object,
        default: () => ({
          top: 0,
          left: 0,
          width: 100,
          height: 100
        })
      },
    },
    computed: {
      sectionIndex() {
        const sections = this.$store.state.page.pageData.sections;
        return this.sectionId ? sections.findIndex((section) => section.id == this.sectionId) : 0;
      },
    },
    methods: {
      showAddSection() {
        if(this.sectionId) {
          this.$store.commit('editor/showAddSection', { index: this.sectionIndex })
        }
      },
      showAddSectionNext() {
        if(this.sectionId) {
          this.$store.commit('editor/showAddSection', { index: this.sectionIndex + 1 })
        }
      },
      deleteSection() {
        if(this.sectionId) {
          this.$store.commit('page/deleteSection', { index: this.sectionIndex });

          this.$store.commit('editor/hideSectionBox');
          this.$store.commit('editor/hideHoverBox');
          this.$store.commit('editor/hideActiveBox');
        }
      },
      moveSectionUp() {
        if(this.sectionId) {
          this.$store.commit('page/moveSectionUp', { index: this.sectionIndex });
        }
      },
      moveSectionDown() {
        if(this.sectionId) {
          this.$store.commit('page/moveSectionDown', { index: this.sectionIndex });
        }
      },
      async duplicateSection() {
        if(this.sectionId) {
          const newId = await this.$store.dispatch('page/duplicateSection', { index: this.sectionIndex });
          this.$message({
            message: '模块复制成功，新模块已添加到原始模块下方！',
            type: 'success'
          });
          // 添加成功后滚入视口
          const newElm = document.querySelector('[data-jr-section-id="' + newId + '"]');
          newElm && newElm.scrollIntoView && newElm.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
      }
    }
  }
